<template>
    <span>
        <span v-if="hasDiffusion">
            <ubi-panel size="sm">
            <div class="block" style="height: 345px;">
               <div class="block-header">
              <h4>{{$t('dashboard.myLastAds')}}</h4>
            </div>
            <div class="block-body">
              <el-table :data="posts" :show-header="false" :cell-style="postsTableCellStyle">
                <el-table-column :width="110">
                    <template v-slot="{ row: post }">
                        <router-link :to="{ name: 'post-view',params: { post: post.id }}"
                                     style="text-decoration:none; color: lightseagreen;">
                            <img v-if="post.photoPrincipale != null"
                                 :src="post.photoPrincipale.url_miniature" height="60" alt="">
                            <span v-else><ubi-icon name="camera" size='40'/></span></router-link>
                    </template>
                </el-table-column>
                <el-table-column label="Titre">
                    <template v-slot="{ row: post }">

                        <div class="Dashboard-post">
                            <router-link router-link :to="{ name: 'post-view', params: { post: post.id } }"
                                         type="info" class="linkRefAnnonceDashboard">
                                <div class="Dashboard-post-title" @click="eventAnalytics('fiche_produit')">
                                    <el-tags-post :post="post" :size="tagPostSize"></el-tags-post>
                                    {{ post.reference }}</div>

                            </router-link>
                            <div class="Dashboard-post-date">{{ post.dateCreation.substring(0,16) }}
                            </div>
                          <!--<div class="Dashboard-post-tag">Diffusée</div>-->
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            </div>
            <div class="block-footer">
              <router-link slot="footer" :to="{ name: 'posts' }">
                  <el-link @click="eventAnalytics('acces_annonces')">{{ $t("dashboard.myLastAdsLink") }}</el-link>
              </router-link>
            </div>
            </div>
        </ubi-panel>
        </span>
    </span>

</template>
<script>

import TagsPosts from './TagsPosts'
import i18next from 'i18next'
import { mapGetters } from 'vuex'
import UbiIcon from '@/components/Icon.vue'
import UbiPanel from '@/components/Panel.vue'
export default {
  name: 'MyLastAds',
  components: {
    UbiPanel,
    UbiIcon,
    ElTagsPost: TagsPosts
  },
  props: ['posts'],
  data () {
    return {
      tagPostSize: 'mini'
    }
  },
  methods: {
    eventAnalytics (category) {
      this.$ga.event('dashboard', 'clic', category, this.sitimmoUser.id)
    },
    postsTableCellStyle ({ row: post, columnIndex }) {
      if (columnIndex === 0) {
        return {
          backgroundSize: 'cover'
        }
      }
      if (columnIndex === 1) {
        return {
          background: '#184957',
          color: 'white'
        }
      }
    },
    productPath (type, job = null) {
      const lang = this.lang === 'mx' ? 'es' : this.lang
      let path = 'products/' + this.getUniverse.toLowerCase() + '/' + type + '_'
      if (job && this.getUniverse.toLowerCase() === 'immo') {
        path += this.getJob.toLowerCase() + '_'
      }
      path += lang + '.png'
      return path
    }
  },
  computed: {
	  ...mapGetters('productLine', ['hasDiffusion']),
	  ...mapGetters(['getUniverse', 'getJob']),
    user () {
      return this.$store.getters.getUser
    },
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    },
    universe () {
      return this.sitimmoUser.univers
    },
    job () {
      return this.sitimmoUser.metier
    },
    sitimmoLogin () {
      return this.sitimmoUser.login
    },
    username () {
      return this.user.username
    },
    typeOffre () {
      return this.post.typeOffre
    },
    typeObjet () {
      return this.post.typeObjet
    },
    isPromoteur () {
      return this.sitimmoUser.metier === 'PROMOTEUR'
    },
    isCmiste () {
      return this.sitimmoUser.metier === 'CMI'
    },
    isBailleurSocial () {
      return this.sitimmoUser.metier === 'BAILLEUR_SOCIAL'
    },
    possedeInstagram () {
      return this.user.possedeInstagram
    },
    lang () {
      return i18next.language
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/theme/_bootstrap.scss";
.el-loading-spinner{
  top:10%!important;
}
.Dashboard {
  &-post {
    @extend .py-2, .px-3;
  }

  &-post-title {
    @extend .font-secondary, .font-weight-bold, .mb-0;
  }

  &-post-date {
    font-size: $font-size-sm;
  }

  &-post-tag {
    @extend .px-2, .font-weight-bolder;
    color: $black;
    background: $yellow;
    font-size: $font-size-xs;
    position: absolute;
    right: map-get($spacers, 2);
    text-transform: uppercase;
    top: map-get($spacers, 2);
  }
}

.linkRefAnnonceDashboard{
  text-decoration: none;
  color: white;
}
.linkRefAnnonceDashboard:hover{
  color: white;
  text-decoration-color: white;
}
</style>
